enum PaymentPlanType {
    OneTimeScheduled = 'OneTimeScheduled',
    RecurringWeekly = 'RecurringWeekly',
    RecurringBiWeekly = 'RecurringBiWeekly',
    RecurringMonthly = 'RecurringMonthly',
    RecurringYearly = 'RecurringYearly',
}

export default PaymentPlanType;
